import type { ReactNode } from 'react'
import { Skeleton } from '@/components/ui/skeleton'
import {
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'

type V2CatalogTableFrameProps = {
  isLoading: boolean
  skeletonColumnCount: number
  skeletonRowCount?: number
  children: ReactNode
}

export function V2CatalogTableFrame({
  isLoading,
  skeletonColumnCount,
  skeletonRowCount = 6,
  children,
}: V2CatalogTableFrameProps) {
  if (isLoading) {
    return (
      <div
        className="overflow-hidden rounded-md border"
        aria-busy="true"
      >
        <table className="w-full min-w-full table-fixed caption-bottom text-sm">
          <TableHeader>
            <TableRow className="group/row">
              {Array.from({ length: skeletonColumnCount }, (_, index) => (
                <TableHead
                  key={index}
                  className="sticky top-0 z-10 bg-background group-hover/row:bg-muted"
                >
                  <Skeleton className="h-4 w-24" />
                </TableHead>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody>
            {Array.from({ length: skeletonRowCount }, (_, rowIndex) => (
              <TableRow key={rowIndex} className="group/row">
                {Array.from({ length: skeletonColumnCount }, (__, cellIndex) => (
                  <TableCell
                    key={cellIndex}
                    className="bg-background group-hover/row:bg-muted"
                  >
                    <Skeleton className="h-4 w-full max-w-48" />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </table>
      </div>
    )
  }

  return (
    <div className="overflow-hidden rounded-md border">
      <div className="overflow-auto">{children}</div>
    </div>
  )
}
